export const jsonPost = (e) => {
  let json = [];
  let i = 0;
  let target = e.target;
  while (i < target.length) {
    let IdPregunta = target[i].name;
    if (target[i].name !== "g-recaptcha-response") {
      if (target[i].checked) {
        if (json[i] === undefined) {
          if (isNaN(target[i].value)) {
            json.push({
              IdPregunta: IdPregunta,
              IdRespuesta: target[i].id,
              subPreguntaId: target[i].getAttribute("subpreguntaid"),
            });
          } else {
            json.push({
              IdPregunta: IdPregunta,
              IdRespuesta: target[i].value,
              subPreguntaId: target[i].getAttribute("subpreguntaid"),
            });
          }
        }
      }

      if (
        (target[i].type === "text" || target[i].type === "email") &&
        target[i].value !== "" &&
        target[i].name !== "" &&
        !target[i].id.startsWith("react-select-")
      ) {
        json.push({
          IdPregunta: target[i].name,
          TextoRespuesta: target[i].value,
          type: "text",
          subPreguntaId: target[i].getAttribute("subpreguntaid"),
        });
      }

      if (
        target[i].id == "select" &&
        target[i].selectedOptions[0].innerText != "Elige una opción"
      ) {
        json.push({
          IdPregunta: IdPregunta,
          //TextoRespuesta: target[i].selectedOptions[0].innerText,
          IdRespuesta: target[i].selectedOptions[0].id,
          type: "select",
          subPreguntaId:
            target[i].selectedOptions[0].getAttribute("subpreguntaid"),
        });
      }

      if (target[i].id === "Autocomplete" && target[i].value != "") {
        json.push({
          IdPregunta: target[i].name,
          IdRespuesta: target[i].value,
          type: "Autocomplete",
          subPreguntaId: target[i].getAttribute("subpreguntaid"),
        });
      }

      if (!target[i].checked && Number(IdPregunta) < Number(target[i].name)) {
        if (target[i].checked)
          json.push({
            IdPregunta: target[i].name,
            IdRespuesta: target[i].name,
          });
      }

      if (target[i].type === "textarea" && target[i].value != "") {
        json.push({
          IdPregunta: target[i].name,
          TextoRespuesta: target[i].value,
          type: "text",
          subPreguntaId: target[i].getAttribute("subpreguntaid"),
        });
      }
      IdPregunta = target[i].name;
    }
    i++;
  }
  //console.log(json)
  return json;
};
